import forEach from 'lodash/forEach';
import { openOverlay } from './gallery';

const classes = {
	videoOverlay: 'VideoOverlay',
};

const selectors = {
	videoOverlay: `.${classes.videoOverlay}`,
	videoPlaceholderImageButton: '.VideoPlaceholderImage-button',
	galleryOverlay: '.Gallery-overlay',
};

let flickityInstances = {};

function openGalleryOverlay(videoOverlayElement, targetElement) {
	const videoOverlayId = videoOverlayElement.getAttribute('id');
	const overlay = videoOverlayElement.querySelector(selectors.galleryOverlay);
	if (!flickityInstances[videoOverlayId]) {
		flickityInstances[videoOverlayId] = openOverlay($(overlay), null, targetElement);
	} else {
		flickityInstances[videoOverlayId] = openOverlay(
			$(overlay),
			flickityInstances[videoOverlayId],
			targetElement
		);
	}
}

function initializeVideoOverlay(element) {
	const videoOverlayButton = element.querySelector(selectors.videoPlaceholderImageButton);

	if (videoOverlayButton) {
		videoOverlayButton.addEventListener('click', e => {
			openGalleryOverlay(element, videoOverlayButton);
		});
	}
}

export default function videoOverlay(openOverlayFunction) {
	const allVideoOverlays = document.querySelectorAll(selectors.videoOverlay);
	forEach(allVideoOverlays, initializeVideoOverlay);
}
